<template>
    <ul class="lawcommon">
        <li v-if="activeId!=''">
            <img style="width:27px;height:26px;" src="./images/law6.png" alt='版权登记'/>
            <div>版权取证</div>
            <p class="lawpf">已经发现侵权，</p>
            <p class="lawps">立即进行取证，固定证据</p>
            <input @click="goJump('6')" type="button" value="办理" />
        </li>
        <li v-if="activeId!=1">
            <img style="width:30px;height:26px;" src="./images/law1.png" alt='版权登记'/>
            <div>电话问律师</div>
            <p class="lawpf">前海版权公共服务平台专业律师</p>
            <p class="lawps">为您快速解答法律问题</p>
            <input @click="goJump('1')" type="button" value="问律师" />
        </li>
        <li v-if="activeId!=2">
            <img style="width:26px;height:26px;" src="./images/law2.png" alt='版权登记'/>
            <div>合同审核</div>
            <p class="lawpf">专业律师为您起草或审核合同</p>
            <p class="lawps">规避法律风险</p>
            <input @click="goJump('2')" type="button" value="办理" />
        </li>
        <li v-if="activeId!=3">
            <img style="width:28px;height:26px;" src="./images/law3.png" alt='版权登记'/>
            <div>侵权下架</div>
            <p class="lawpf">精英律师顾问团</p>
            <p class="lawps">为您的创业之路保驾护航</p>
            <input @click="goJump('3')" type="button" value="办理" />
        </li>
        <li v-if="activeId!=4">
            <img style="width:22px;height:26px;" src="./images/law4.png" alt='版权登记'/>
            <div>出具律师函</div>
            <p class="lawpf">专业律师为您分析诉讼风险</p>
            <p class="lawps">最大化降低损失</p>
            <input @click="goJump('4')" type="button" value="办理" />
        </li>
        <li v-if="activeId!=5">
            <img style="width:27px;height:26px;" src="./images/law5.png" alt='版权登记'/>
            <div>侵权判定+维权方案设计</div>
            <p class="lawpf">专业律师为您判定侵权、</p>
            <p class="lawps">分析证据制定最优维权方案</p>
            <input @click="goJump('5')" type="button" value="办理" />
        </li>
    </ul>
</template>

<script>
    export default {
        name:'lawcommon',
        props:{
            activeId: {
                type: String,
                default: ''
            },
        },
        data(){
            return {

            }
        },
        methods:{
            goJump(number){
                let _this = this;
                switch(number){
                    case '1':
                        _this.$router.push({path:'/fuwu/dianhua.html'})
                        break;
                    case '2':
                        _this.$router.push({path:'/fuwu/hetong.html'})
                        break;
                    case '3':
                        _this.$router.push({path:'/fuwu/qinquan.html'})
                        break;
                    case '4':
                        _this.$router.push({path:'/fuwu/lvshihan.html'})
                        break;
                    case '5':
                        _this.$router.push({path:'/fuwu/weiquan.html'})
                        break;
                    case '6':
                        _this.$router.push({path:'/evidence'})
                        break;
                    default:
                        break;
                }
            }
        },
        mounted(){

        },
        created(){

        }
    }
</script>

<style scoped lang="less">
    .lawcommon{
        width:1200px;
        height:277px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        display:flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        li{
            flex:1;
            list-style: none;
            width:266px;
            padding-left:63px;
            height:277px;
            display: flex;
            flex-direction: column;
            &:hover{
                height:277px;
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
                cursor: pointer;
            }
            img{
                margin-top:40px;
                margin-bottom:26px;
            }
            div{
                height:25px;
                font-size:18px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:25px;
                margin-bottom:15px;
            }
            .lawpf{
                height:20px;
                font-size:14px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:20px;
            }
            .lawps{
                height:20px;
                font-size:14px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:20px;
            }
            input{
                width:124px;
                height:33px;
                background:rgba(255,216,0,1);
                border-radius:2px;
                font-size:12px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:33px;
                cursor: pointer;
                outline: none;
                border:none;
                margin-top:25px;
            }
        }
    }
</style>